import { defineStore } from 'pinia'
import ProjectService from "@/services/project/ProjectService";
import NotificationService from "@/services/notification/NotificationService";

// El enlace de Moodle es de un solo uso y caduca en torno a un minuto.
const READY_LINK_TTL_MS = 50000;

let readyLinkTimer = null;

/*
 * Botón «Aula»: obtiene el enlace de acceso a Moodle de un curso y lo abre en una pestaña nueva.
 *
 * Si el navegador bloquea la ventana (se abre después de esperar a la API, fuera del clic),
 * se guarda el enlace en `readyLink` y `ClassroomReadyDialog` ofrece abrirlo con un clic.
 */
export const useClassroomStore = defineStore('classroom', {
    state: () => ({
        loadingProjectUuid: null,
        readyLink: null,
    }),
    getters: {
        isLoading: (state) => (projectUuid) => state.loadingProjectUuid === projectUuid,
        isBusy: (state) => state.loadingProjectUuid !== null,
    },
    actions: {
        // `t` es la función de traducción del componente que llama ($t).
        open(projectUuid, t) {
            if (!projectUuid || this.isBusy) {
                return;
            }

            this.dismiss();
            this.loadingProjectUuid = projectUuid;

            ProjectService.getMoodleCourseURL(projectUuid)
                .then((link) => {
                    const tab = window.open(link, '_blank');

                    if (tab) {
                        tab.opener = null;
                    } else {
                        this.showReadyLink(link);
                    }
                })
                .catch((error) => {
                    if (error?.code === 'ECONNABORTED') {
                        NotificationService.showNotification(t('general.classroom_timeout'), 'error');
                    } else {
                        NotificationService.showApiError(error, t('general.classroom_error'));
                    }
                })
                .finally(() => {
                    this.loadingProjectUuid = null;
                });
        },
        showReadyLink(link) {
            this.readyLink = link;
            clearTimeout(readyLinkTimer);
            readyLinkTimer = setTimeout(() => this.dismiss(), READY_LINK_TTL_MS);
        },
        dismiss() {
            clearTimeout(readyLinkTimer);
            this.readyLink = null;
        },
    },
})
